/**
 * True while an IME (Japanese, Chinese, Korean, …) is mid-composition — the window in which the
 * Enter key CONFIRMS a kana/kanji (or pinyin, or Hangul) candidate rather than meaning "send".
 * A composer that submits on Enter MUST skip that keystroke, or it fires mid-composition and sends
 * the half-formed word (reported: typing 「ます」 sent as soon as the user pressed Enter to pick the
 * conversion).
 *
 * Two signals, because engines drop different ones: `isComposing` is set on the native event for
 * the whole composition; `keyCode === 229` is the sentinel the confirming keydown still carries in
 * some engines (notably Safari/WebKit) where `isComposing` has already flipped false by the time the
 * event reaches the handler. Checking both is the standard belt-and-suspenders guard.
 *
 * Web-only by nature: the native chat composers send from a button and leave Enter as a newline, so
 * they have no Enter-to-send keystroke to disambiguate from an IME confirmation.
 */
export function isImeComposing(e: {
  readonly nativeEvent: { readonly isComposing?: boolean };
  readonly keyCode?: number;
}): boolean {
  return Boolean(e.nativeEvent?.isComposing) || e.keyCode === 229;
}
